import { KeyFacts } from '@/components/patterns/KeyFacts'
import type { CrmLastContact, CrmNextAction } from '../types'
import { lastContactText, monthYear, nextActionText } from './format'

export type RhythmState = 'geen' | 'op_schema' | 'binnenkort' | 'gemist'

/** Words, never colour alone (IA-20). */
const RHYTHM_WORDS: Record<Exclude<RhythmState, 'geen'>, string> = {
  op_schema: '✓ op schema',
  binnenkort: '⚠ binnenkort',
  gemist: '! gemist',
}

/**
 * The key facts of a contact or an organisation: since when, when last in touch (ED-23)
 * and the next action (the first line of Gepland), and the state of the contact rhythm (E4).
 */
export function RelationKeyFacts({
  relationSince,
  lastContact,
  nextAction,
  rhythm = null,
}: {
  relationSince: string | null
  lastContact: CrmLastContact | null
  nextAction: CrmNextAction | null
  rhythm?: RhythmState | null
}) {
  const facts = [
    { label: 'Relatie sinds', value: monthYear(relationSince) },
    { label: 'Laatste contact', value: lastContactText(lastContact) },
    { label: 'Volgende actie', value: nextAction ? nextActionText(nextAction) : 'Niets gepland' },
  ]
  if (rhythm && rhythm !== 'geen') facts.push({ label: 'Contactritme', value: RHYTHM_WORDS[rhythm] })
  return (
    <KeyFacts facts={facts} />
  )
}
